import { requester } from '../utils';

export const fetchAllCheckouts = query => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/checkout-with-cafe/cafes?${query}`,
        method: 'GET',
        withAuth: true,
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        console.log('fetch users error', err);
        reject(err);
      });
  });
};

export const fetchReservesCheckoutReportById = (checkoutWithCafeId, query) => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/checkout-with-cafe/cafe/reserves/${checkoutWithCafeId}?${query}`,
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const postCheckout = data => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/checkout-with-cafe`,
        method: 'POST',
        data,
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const fetchCheckoutCafe = cafeId => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/cafe-contract/bank-info/${cafeId}`,
        method: 'GET',
        withAuth: true,
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};

